module.exports = __webpack_public_path__ + "static/media/Projects.85dd9360.svg";